/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { List } from '@app/data-model/list/list';
import { SearchParams } from '@app/common/types/search-params';

export class SearchList extends List {
  id: string;
  displayName: string;
  sortData: any;
  searchCriteriaInfo: SearchParams;
  displayResultCount: boolean;
  isFilterable = true;
  isSortable = true;
  isAdvancedSearchList = false;

  constructor(displayName: string, searchCriteriaInfo, config?) {
    super('search-list');
    config = config || ({ displayResultCount: true } as any);
    this.id = 'search-list';
    this.displayName = displayName;
    this.searchCriteriaInfo = searchCriteriaInfo;
    this.displayResultCount = config.displayResultCount;
    if (config && config.isAdvancedSearchList !== undefined) {
      this.isAdvancedSearchList = config.isAdvancedSearchList;
    }
  }
}
